import { buildNupayState, encodeNupayState } from "../api/checkAuthStatus";
import { notifySuccessfulAuth } from "../api/notifySuccessfulAuth";
import { PaymentState } from "../context";

export const notifySuccessfulEnrollment = (context, _event) =>
  // eslint-disable-next-line no-async-promise-executor
  new Promise(async (resolve, reject) => {
    try {
      const { authorizationCode } = context?.[PaymentState.payment] ?? {};

      await notifySuccessfulAuth({
        authorizationCode,
        nupayOAuthState: encodeNupayState(buildNupayState()),
      });
      resolve(null);
    } catch (error) {
      reject({
        error,
      });
    }
  });
